export const ShopInitialState = {
  activeShopId: "",
};

export interface shopType {
  activeShopId?: string;
}
